// LowerCase Token Address Array.
// order Metters return order.
// more common more back.
export const CommonTokens = [
  "0x853d955acef822db058eb8505911ed77f175b99e", //FRAX
  "0x4591dbff62656e7859afe5e45f6f47d3669fbb28", //mkUSD
  "0x6b175474e89094c44da98b954eedeac495271d0f", //DAI
  "0x0000000000085d4780b73119b644ae5ecd22b376", //BUSD
  "0x4fabb145d64652a948d72533023f6e7a623c7c53", //BUSD
  "0x056fd409e1d7a124bd7017459dfea2f387b6d5cd", //GUSD
  "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48", //USDC
  "0xdac17f958d2ee523a2206206994597c13d831ec7", //USDT
  "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599", //WBTC
  "0xae78736cd615f374d3085123a210448e74fc6393", //rETH
  "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2", //WETH
  "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", //ETH
];
